/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Account_N_Technical__NameInputs */

const en_help_center__account_n_technical__name = /** @type {(inputs: Help_Center__Account_N_Technical__NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account & Technical`)
};

/**
* | output |
* | --- |
* | "Account & Technical" |
*
* @param {Help_Center__Account_N_Technical__NameInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__account_n_technical__name = /** @type {((inputs?: Help_Center__Account_N_Technical__NameInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Account_N_Technical__NameInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__account_n_technical__name(inputs)
});